"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATIONS = void 0;
const client_1 = require("@apollo/client");
exports.NOTIFICATIONS = (0, client_1.gql) `
  query Notifications {
    restricted {
      notifications {
        read
        type
        id
        description
        actionType
        createdAt
        fromUser {
          id
          displayName
        }
        comment {
          id
          comment
          question {
            id
            concept {
              id
              name
            }
          }
        }
      }
    }
  }
`;
